<template>
  <Content title="Endosados">
    <Spinner v-if="loading.view"></Spinner>
    <template v-else>
      <Card title="Filtros" icon="fa fa-filter">
        <div class="row">
          <div class="col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">Servicio:</label>
              <InputSelect
                v-model="form.servicio"
                :options="containers.serviciosFiltro"
                label="nombre"
              ></InputSelect>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">Fecha:</label>
              <InputDatepicker v-model="form.fecha"></InputDatepicker>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">Agencia:</label>
              <InputSelect
                v-model="form.agencia"
                :options="containers.agenciasFiltro"
                label="nombre"
              ></InputSelect>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">Pasajero:</label>
              <InputText v-model="form.pasajero"></InputText>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">Código:</label>
              <InputText v-model="form.codigo"></InputText>
            </div>
          </div>
        </div>
      </Card>
      <Card title="Endosados" body-class="p-0">
        <template #toolbar>
          <Button variant="primary" class="btn-sm" @click="onNew">Nuevo</Button>
          <Button
            variant="outline-secondary"
            class="btn-sm ml-2"
            :disabled="loading.endosados || !paginacion.total"
            @click="onPrint"
            >Imprimir</Button
          >
        </template>
        <EndosadosTable
          :rows="containers.endosados"
          :pagination="false"
          @edit="onEdit"
          @delete="onDelete"
          @liquidar="onLiquidar"
        ></EndosadosTable>
        <BPagination
          v-if="paginacion.total > paginacion.porPagina"
          :value="paginacion.pagina"
          :total-rows="paginacion.total"
          :per-page="paginacion.porPagina"
          :disabled="loading.endosados"
          first-number
          last-number
          :limit="6"
          align="center"
          class="mt-5"
          @input="onCambiarPagina"
        ></BPagination>
      </Card>
      <EndosadoModal
        v-if="containers.showEndosadoModal"
        :modalItem="containers.endosadoModalItem"
        @hide="containers.showEndosadoModal = false"
        @save="onSave"
      ></EndosadoModal>
      <EndosadoLiquidarModal
        v-if="containers.showEndosadoLiquidarModal"
        :modalItem="containers.endosadoLiquidarModalItem"
        @hide="onHideLiquidarModal"
      ></EndosadoLiquidarModal>
    </template>
  </Content>
</template>

<script>
import { BPagination } from "bootstrap-vue";

import EndosadoLiquidarModal from "../components/EndosadoLiquidarModal.vue";
import EndosadoModal from "../components/EndosadoModal.vue";
import EndosadosTable from "../components/EndosadosTable.vue";
import Spinner from "../../shared/components/Spinner.vue";
import Button from "../../shared/components/Button.vue";
import InputText from "../../shared/components/InputText.vue";
import InputSelect from "../../shared/components/InputSelect.vue";
import InputDatepicker from "../../shared/components/InputDatepicker.vue";
import Card from "../../shared/components/Card.vue";
import Content from "../../shared/components/Content.vue";
import { debounce } from "../../shared/helpers";
import pdfEndosados from "../../../pdfs/pdfEndosados";

export default {
  components: {
    Content,
    Card,
    InputSelect,
    InputDatepicker,
    InputText,
    Button,
    Spinner,
    EndosadosTable,
    EndosadoModal,
    EndosadoLiquidarModal,
    BPagination
  },
  data() {
    return {
      form: {
        servicio: null,
        fecha: "",
        agencia: null,
        pasajero: "",
        codigo: ""
      },
      loading: {
        view: true,
        endosados: false
      },
      paginacion: {
        pagina: 1,
        porPagina: 20,
        total: 0,
        ultimaPagina: 0
      },
      inicializado: false,
      solicitudEndosados: 0,
      containers: {
        endosados: [],
        serviciosFiltro: [],
        agenciasFiltro: [],
        showEndosadoModal: false,
        endosadoModalItem: null,
        showEndosadoLiquidarModal: false,
        endosadoLiquidarModalItem: null
      }
    };
  },
  async created() {
    try {
      await this.cargarFiltros();
      await this.cargarEndosados();
    } catch (error) {
      console.error(error?.response || error);
    } finally {
      this.inicializado = true;
      this.loading.view = false;
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        if (!this.inicializado) return;

        this.solicitudEndosados += 1;
        this.loading.endosados = true;
        this.onCambiarFiltros();
      }
    }
  },
  methods: {
    async cargarFiltros() {
      const response = await this.axios.get("/endosados/filtros");
      this.containers.serviciosFiltro = response.data.content.serviciosFiltro;
      this.containers.agenciasFiltro = response.data.content.agenciasFiltro;
    },
    parametrosFiltros(form = this.form) {
      const parametros = {};

      if (form.servicio?.idServicio) {
        parametros.idServicio = form.servicio.idServicio;
      }

      if (form.fecha) {
        parametros.fecha = form.fecha;
      }

      if (form.agencia?.idAgencia) {
        parametros.idAgencia = form.agencia.idAgencia;
      }

      const pasajero = String(form.pasajero || "").trim();
      if (pasajero) {
        parametros.pasajero = pasajero;
      }

      const codigo = String(form.codigo || "").trim();
      if (codigo) {
        parametros.codigo = codigo;
      }

      return parametros;
    },
    parametrosEndosados() {
      return {
        ...this.parametrosFiltros(),
        pagina: this.paginacion.pagina,
        porPagina: this.paginacion.porPagina
      };
    },
    prepararEndosado(item) {
      let observacionesExtras = [];

      if (item.horaTicket) {
        observacionesExtras.push(
          `<strong>HT</strong>: ${this.$options.filters.date(
            item.horaTicket,
            "HH:mm:ss",
            "HH:mm"
          )}`
        );
      }
      if (item.horaHuayna) {
        observacionesExtras.push(
          `<strong>HHP</strong>: ${this.$options.filters.date(
            item.horaHuayna,
            "HH:mm:ss",
            "HH:mm"
          )}`
        );
      }
      if (item.hotelOvernight) {
        observacionesExtras.push(
          `<strong>ON</strong>: ${item.hotelOvernight}`
        );
      }
      if (item.restaurante) {
        observacionesExtras.push(`<strong>L</strong>: ${item.restaurante}`);
      }
      if (item.idOrigen) {
        observacionesExtras.push(`<strong>OR</strong>: ${item.origen}`);
      }
      if (item.idDestino) {
        observacionesExtras.push(`<strong>DE</strong>: ${item.destino}`);
      }

      observacionesExtras = observacionesExtras.join(" / ");

      return {
        ...item,
        trenInOut: {
          in: String(item.trenIn || "").trim(),
          out: String(item.trenOut || "").trim()
        },
        horaRecojoInicio: {
          recojo: String(item.horaRecojo || "").trim(),
          inicio: String(item.horaInicio || "").trim()
        },
        vehiculoConductor: {
          vehiculo: String(item.vehiculo || "").trim(),
          otroVehiculo: String(item.otroVehiculo || "").trim(),
          conductor: String(item.conductor || "").trim(),
          otroConductor: String(item.otroConductor || "").trim()
        },
        observacionesExtras: observacionesExtras.length
          ? observacionesExtras
          : null
      };
    },
    async cargarEndosados() {
      const solicitud = ++this.solicitudEndosados;
      this.loading.endosados = true;

      try {
        const response = await this.axios.get("/endosados", {
          params: this.parametrosEndosados()
        });

        if (solicitud !== this.solicitudEndosados) return;

        const endosados = response.data.content.endosados.map(item =>
          this.prepararEndosado(item)
        );
        const paginacion = response.data.paginacion;

        if (
          !endosados.length &&
          this.paginacion.pagina > 1 &&
          paginacion.ultimaPagina < this.paginacion.pagina
        ) {
          this.paginacion.pagina = Math.max(1, paginacion.ultimaPagina);
          await this.cargarEndosados();
          return;
        }

        this.containers.endosados = endosados;
        this.paginacion = paginacion;
      } catch (error) {
        if (solicitud === this.solicitudEndosados) {
          console.error(error?.response || error);
        }
      } finally {
        if (solicitud === this.solicitudEndosados) {
          this.loading.endosados = false;
        }
      }
    },
    onCambiarFiltros: debounce(function() {
      this.paginacion.pagina = 1;
      this.cargarEndosados();
    }, 400),
    onCambiarPagina(pagina) {
      if (pagina === this.paginacion.pagina) return;

      this.paginacion.pagina = pagina;
      this.cargarEndosados();
    },
    onNew() {
      this.containers.endosadoModalItem = null;
      this.containers.showEndosadoModal = true;
    },
    onEdit(item) {
      this.containers.endosadoModalItem = item;
      this.containers.showEndosadoModal = true;
    },
    async onDelete({ idEndose }) {
      const { isConfirmed } = await this.$confirm.fire({
        text: "¿Seguro que desea eliminar este registro?"
      });

      if (!isConfirmed) return;

      try {
        await this.axios.delete(`/endosados/${idEndose}`);
        await Promise.all([this.cargarFiltros(), this.cargarEndosados()]);
      } catch (error) {
        console.error(error?.response || error);
      }
    },
    async onSave() {
      const esNuevo = !this.containers.endosadoModalItem;

      this.containers.showEndosadoModal = false;
      this.containers.endosadoModalItem = null;

      if (esNuevo) {
        this.paginacion.pagina = 1;
      }

      try {
        await Promise.all([this.cargarFiltros(), this.cargarEndosados()]);
      } catch (error) {
        console.error(error?.response || error);
      }
    },
    onLiquidar(item) {
      this.containers.endosadoLiquidarModalItem = item;
      this.containers.showEndosadoLiquidarModal = true;
    },
    onPrint() {
      if (this.loading.endosados || !this.paginacion.total) return;

      const vm = this;

      const endoses = this.containers.endosados.map(item => ({
        ...item,
        horaInicio: vm.$options.filters.date(
          item.horaInicio,
          "HH:mm:ss",
          "HH:mm"
        ),
        horaRecojo: vm.$options.filters.date(
          item.horaRecojo,
          "HH:mm:ss",
          "HH:mm"
        ),
        horaHuayna: vm.$options.filters.date(
          item.horaHuayna,
          "HH:mm:ss",
          "HH:mm"
        ),
        horaTicket: vm.$options.filters.date(
          item.horaTicket,
          "HH:mm:ss",
          "HH:mm"
        ),
        fecha: vm.$options.filters.date(item.fecha),
        vehiculo:
          String(item.vehiculo || '').trim() ||
          String(item.otroVehiculo || '').trim() ||
          "",
        conductor:
          String(item.conductor || '').trim() ||
          String(item.otroConductor || '').trim() ||
          ""
      }));

      pdfEndosados({
        endoses,
        servicio: vm.form.servicio?.nombre || "",
        fechaInicio: vm.$options.filters.date(vm.form.fecha),
        agencia: vm.form.agencia?.nombre || "",
        pasajero: vm.form.pasajero || "",
        userMark: vm.$store.state.user,
        dateMark: vm.$dayjs().format("DD-MM-YY HH:mm")
      });
    },
    async onHideLiquidarModal(recargar) {
      this.containers.showEndosadoLiquidarModal = false;
      this.containers.endosadoLiquidarModalItem = null;

      if (recargar) {
        await this.cargarEndosados();
      }
    }
  }
};
</script>

<style></style>
